import React from 'react';
import styled, { css } from 'styled-components';

import { useCardContext } from './card-context';

/** Strain type pill and potency values (THC, CBD, TAC). Renders nothing when both are absent. */
export function CardStrainDetails(): JSX.Element | null {
  const { strainType, potency } = useCardContext();

  if (!strainType && potency.length === 0) {
    return null;
  }

  return (
    <Details>
      {strainType && <Strain data-testid='card-strain'>{strainType}</Strain>}
      {potency.length > 0 && <Potency $isMissingStrain={!strainType}>{potency.join(' · ')}</Potency>}
    </Details>
  );
}

const Details = styled.div`
  min-height: 42px;
  margin-top: 16px;
`;

const Strain = styled.div`
  background: #e3e7e9;
  border-radius: 12px;
  color: #2c3236;
  display: inline-block;
  font: 500 12px/1 ${({ theme }) => theme.customized.fonts.secondary};
  padding: 6px 8px;
`;

const Potency = styled.div<{ $isMissingStrain?: boolean }>`
  color: #646d72;
  font: 12px/1 ${({ theme }) => theme.customized.fonts.secondary};
  margin-top: 6px;

  ${({ $isMissingStrain }) =>
    $isMissingStrain &&
    css`
      padding-top: 24px;
    `}
`;
